import Immutable from 'immutable';
import actionTypes from './constants';

////////////////// EDIT //////////////////

const $$initialState = Immutable.fromJS({
  info_box_enabled: true,
  show_spinner: false,
  submit_button_enabled: true,
});

////////////////// EDIT //////////////////

function appReducer($$state = $$initialState, action) {
  const { payload } = action;

  switch (action.type) {
    case actionTypes.UPDATE_INPUT_FIELD:
      return $$state.updateIn(
        ['submit_params', 'fields', payload.index, 'answer'],
        val => payload.value
      );
    case actionTypes.CLOSE_INFO_BOX:
      return $$state.updateIn(['info_box_enabled'], val => false);
    case actionTypes.SET_SPINNER:
      return $$state.updateIn(['show_spinner'], val => payload.bool);
    case actionTypes.SUBMIT_BUTTON_ENABLED:
      return $$state.updateIn(['submit_button_enabled'], val => payload.bool);
    default:
      return $$state;
  }
}

////////////////// PERMANENT //////////////////
export default {
  $$appStore: appReducer,
};

export const initialStates = {
  $$initialState,
};
